import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { IUser, fadeUp, vshrink } from 'shared';

import { UserFilter } from '../../../../models/user-filter.model';
import { allowAll } from '../../../../utils/allow-all.filter';
import { FocusOnHoverDirective, FocusableDirective } from '../../../directives';
import { UserService } from '../../../services';
import { ContextListItemComponent } from '../../util/context-list/context-list-item/context-list-item.component';
import { ContextListComponent } from '../../util/context-list/context-list.component';
import { BaseSearchablePopupComponent } from '../base-popup/base-searchable-popup.component';

const MAX_RESULTS = 6;

@Component({
    selector: 'app-user-select-popup',
    templateUrl: './user-select-popup.component.html',
    styleUrls: ['./user-select-popup.component.scss'],
    animations: [fadeUp('popup'), vshrink('listItem'), vshrink('listHeader')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ContextListComponent,
        FocusableDirective,
        ContextListItemComponent,
        FocusOnHoverDirective,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class UserSelectPopupComponent extends BaseSearchablePopupComponent<IUser> {
    protected readonly userService = inject(UserService);

    // Options
    protected hideFiltered = true;

    protected get userFilter(): UserFilter {
        return this._userFilter ?? allowAll;
    }

    protected set userFilter(value: UserFilter) {
        this._userFilter = value;
    }

    private _userFilter?: UserFilter;

    public constructor() {
        super();

        this.initialize(
            'fullName',
            this.userService.filterUsers(this.hideFiltered ? this.userFilter : null),
            MAX_RESULTS
        );
    }

    protected async selectUser(user?: IUser): Promise<void> {
        if (user && !(await firstValueFrom(this.userFilter(user)))) return;
        this.popupResult.emit(user);
    }
}
